import React, { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import WhatApp from "./components/wa/WhatApp"; 
import AnimatedRoutes from "./AnimatedRoutes";
import UpButton from "./components/UpButton/UpButton"; 
import './app.css';

function App() {
  const [activeTab, setActiveTab] = useState("home");
  const [isWhatsAppOpen, setIsWhatsAppOpen] = useState(false); 

  return (
    <Router>
      <Navbar activeTab={activeTab} setActiveTab={setActiveTab} />
      <AnimatedRoutes />
      <WhatApp isOpen={isWhatsAppOpen} setIsOpen={setIsWhatsAppOpen} /> 
      <UpButton activeTab={activeTab} isWhatsAppOpen={isWhatsAppOpen} />
      <Footer />
    </Router>
  );
}

export default App;